import { render, staticRenderFns } from "./logEdit.vue?vue&type=template&id=386f665d&scoped=true&"
import script from "./logEdit.vue?vue&type=script&lang=js&"
export * from "./logEdit.vue?vue&type=script&lang=js&"
import style0 from "./logEdit.vue?vue&type=style&index=0&id=386f665d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f665d",
  null
  
)

export default component.exports